import request from '@/utils/request'
import {
    baseUrl
} from './baseUrl.js'

/**
 * 查询跟团游列表（WAP端，仅展示状态为展示的）
 * 复用 PC 后端接口 /groupTour/manage/list
 * @param data
 */
export function akGroupTourList(data) {
    return request({
        url: baseUrl + '/groupTour/manage/list',
        method: 'post',
        data: {
            ...data,
            showStatus: 1  // 固定只查展示状态的跟团游
        }
    })
}

/**
 * 查询跟团游详情（WAP端）
 * 复用 PC 后端接口 /groupTour/manage/detail/:id
 * @param data
 */
export function akGroupTourDetail(data) {
    const id = data.id
    return request({
        url: baseUrl + `/groupTour/manage/detail/${id}`,
        method: 'get'
    })
}

/**
 * 获取跟团游报价（WAP端）
 * 复用 PC 后端接口 /groupTour/manage/quote
 * @param data
 */
export function akGroupTourQuote(data) {
    return request({
        url: baseUrl + '/groupTour/manage/quote',
        method: 'post',
        data
    })
}
